module.exports = __webpack_public_path__ + "static/media/how_to_claim.c0415786.mp4";